module.exports = __webpack_public_path__ + "img/step05_a_stand_basic_right_bottom_cross.b5b93ded.png";